/**
 * Centralized FormattedMessage / formatMessage IDs for the WTN
 * (Waste Transfer Note) feature. Keep all `wtn.*` keys here so
 * additions and renames stay in one place and matching translations
 * can be audited in the locale JSON files.
 */

export const WTN_MSG = Object.freeze({
    HEADING: "wtn.heading",
    CONTAINERS: "wtn.containers",
    FILTERS: "wtn.filters",
    SEARCH: "wtn.search",
    CLEAR_ALL: "wtn.clearAll",
    SEARCH_RESULTS: "wtn.searchResults",
    DOWNLOAD: "wtn.download",
    NO_RESULTS: "wtn.noResults",
    PER_PAGE: "wtn.perPage",
    PREVIOUS: "wtn.previous",
    NEXT: "wtn.next",
    DEFAULT_SCOPE_HINT: "wtn.defaultScopeHint",

    ERROR: Object.freeze({
        LOAD_FAILED: "wtn.error.loadFailed",
        DOWNLOAD_FAILED: "wtn.error.downloadFailed"
    }),

    FILTER: Object.freeze({
        ITEM_CREATE_DATE: "wtn.filter.itemCreateDate",
        WASTE_CODE: "wtn.filter.wasteCode",
        DOCUMENT_ID: "wtn.filter.documentId",
        CUSTOMER_ORDER_ID: "wtn.filter.customerOrderId",
        ITEM_NAME: "wtn.filter.itemName",
        CONTAINER_ID: "wtn.filter.containerId"
    }),

    TABLE: Object.freeze({
        DOCUMENT_ID: "wtn.table.documentId",
        WASTE_CODE: "wtn.table.wasteCode",
        CUSTOMER_PICKUP_DATE: "wtn.table.customerPickupDate",
        ITEM_CREATE_DATE: "wtn.table.itemCreateDate",
        ITEM_NAME: "wtn.table.itemName",
        CONTAINER_ID: "wtn.table.containerId",
        CUSTOMER_ORDER_ID: "wtn.table.customerOrderId"
    }),

    CONTAINER: Object.freeze({
        HEADING: "wtn.container.heading",
        CLOSE: "wtn.container.close",
        ID: "wtn.container.id",
        CREATED_AT: "wtn.container.createdAt",
        PRINT_LABELS: "wtn.container.printLabels",
        ADD_ITEMS: "wtn.container.addItems",
        VIEW_DETAILS: "wtn.container.viewDetails",
        CREATE_CONTAINER: "wtn.container.createContainer",
        NO_RESULTS: "wtn.container.noResults",
        SHOWING: "wtn.container.showing",
        RESULTS: "wtn.container.results",
        FILTERS: "wtn.container.filters",

        BARCODE: Object.freeze({
            ERROR: "wtn.container.barcode.error"
        }),

        STATUS: Object.freeze({
            OPEN: "wtn.container.status.open",
            CLOSE: "wtn.container.status.close"
        }),

        FILTER: Object.freeze({
            STATUS: "wtn.container.filter.status",
            STATUS_ALL: "wtn.container.filter.status.all",
            STATUS_OPEN: "wtn.container.filter.status.openOption",
            STATUS_CLOSED: "wtn.container.filter.status.closedOption",
            CREATED_DATE: "wtn.container.filter.createdDate"
        }),

        DETAILS: Object.freeze({
            CLOSE: "wtn.container.details.close",
            CONTAINER_INFO: "wtn.container.details.containerInfo",
            CONTAINER_ID: "wtn.container.details.containerId",
            STATUS: "wtn.container.details.status",
            CREATED_DATE: "wtn.container.details.createdDate",
            ITEMS: "wtn.container.details.items",
            WASTE_CODE_ADDED: "wtn.container.details.wasteCodeAdded",
            NO_ITEMS: "wtn.container.details.noItems",
            LOAD_FAILED: "wtn.container.details.error.loadFailed",
            SHOWING_COUNT: "wtn.container.details.showingCount",
            WEIGHT_PROGRESS: "wtn.container.details.weightProgress"
        }),

        CREATE: Object.freeze({
            TITLE: "wtn.container.create.title",
            CANCEL: "wtn.container.create.cancel",
            SAVE: "wtn.container.create.save",
            WASTE_PROFILE_CODE: "wtn.container.create.wasteProfileCode",
            CONTAINER_TYPE: "wtn.container.create.containerType",
            MAX_WEIGHT: "wtn.container.create.maxWeight"
        }),

        CREATE_ITEM: Object.freeze({
            TITLE: "wtn.container.createItem.title",
            CANCEL: "wtn.container.createItem.cancel",
            SAVE: "wtn.container.createItem.save",
            ITEM_NAME: "wtn.container.createItem.itemName",
            ITEM_NAME_PLACEHOLDER: "wtn.container.createItem.itemName.placeholder",
            QUANTITY: "wtn.container.createItem.quantity",
            QUANTITY_PLACEHOLDER: "wtn.container.createItem.quantity.placeholder",
            WEIGHT: "wtn.container.createItem.weight",
            WEIGHT_PLACEHOLDER: "wtn.container.createItem.weight.placeholder"
        }),

        CLOSE_CONFIRM: Object.freeze({
            TITLE: "wtn.container.closeConfirm.title",
            BODY: "wtn.container.closeConfirm.body",
            CANCEL: "wtn.container.closeConfirm.cancel",
            CONFIRM: "wtn.container.closeConfirm.confirm"
        }),

        ERROR: Object.freeze({
            LOAD_FAILED: "wtn.container.error.loadFailed",
            CLOSE_FAILED: "wtn.container.error.closeFailed",
            CREATE_FAILED: "wtn.container.error.createFailed",
            CREATE_ITEM_FAILED: "wtn.container.error.createItemFailed"
        }),

        SUCCESS: Object.freeze({
            ITEM_ADDED: "wtn.container.success.itemAdded",
            CONTAINER_CREATED: "wtn.container.success.containerCreated"
        })
    })
});



// WEBPACK FOOTER //
// ./src/commons/constants/WtnMessageIds.js